// https://www.heap.io/

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    heap?: {
      identify: Function;
    };
  }
}

export const setUserIdToHeapAnalytics = (userPk: string) => {
  if (userPk && typeof window.heap !== 'undefined') {
    window.heap?.identify?.(userPk);
  }
};
